import { clientSettings } from 'go-modules/models/common/client.settings';

export class OrgSettingsController {
	// Bindings
	public group;
	public user;
	public mayMask: (args: {account, user, role}) => void;
	public loginAs: (args: {user: any}) => void;

	// Local properties
	public accountFilter;
	public accounts = [];
	public options = {selectedAccount: false};
	public adminToolsUrl = '';

	/* @ngInject */
	constructor (
		private Group,
		private $element: ng.IAugmentedJQuery,
		private $timeout: ng.ITimeoutService
	) {}

	public $onInit () {
		this.adminToolsUrl = `${clientSettings.AdminToolsUrl}#/tool/org-settings?searchType=org&group=${this.group.group_id}`;
		this.Group.getOrgAccountsWithStats(this.group.group_id).then((accounts) => this.accounts = accounts);
	}

	public clearSearch () {
		this.accountFilter = '';
		this.$timeout(() => {
			this.$element[0].querySelector<HTMLInputElement>('.search-input').focus();
		});
	}
}
